import React from 'react'
import styles from './Demos.module.scss'
import { ClusterInterface } from '../../../../common/types/interfaces'

interface Props {
  items: ClusterInterface[]
}

export const Demos: React.FC<Props> = ({ items }) => {
  if (!items.length) return null

  return (
    <div className={styles.container}>
      {items.map((c) => (
        <a
          key={c.id}
          className={styles.card}
          href={`https://${c.domain}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.logoWrap}>
            <img
              className={styles.logo}
              src={`https://${c.domain}/icons/logo512.png`}
              alt={c.name}
              loading="lazy"
            />
            <span className={styles.badge}>DEMO</span>
          </div>
          <h3 className={styles.title}>{c.name}</h3>
          {/* <p className={styles.description}>{c.description}</p> */}
        </a>
      ))}
    </div>
  )
}